/**
 * PinSlotContext — exposes the active Stream's pin slot to its
 * descendant cards.
 *
 * When a Stream is configured with explicit `pinScope` / `pinSurface`
 * props (Group page, Collection detail, /collections list), the
 * Stream wraps its render tree in this context. Card-level pin
 * affordances (currently `CollectionBlockView`) read the context to
 * convert "pin" into a single-action toggle against the surrounding
 * slot — no destination dropdown.
 *
 * The context is intentionally absent on Streams that don't pass an
 * explicit pinScope (i.e. the homepage feed): cards rendered there
 * fall back to their own per-card destination heuristics (e.g. the
 * `pinParentTarget` parent-Group detection in `CollectionBlockView`).
 */
import { createContext, useContext } from "react";
export const PinSlotContext = createContext(undefined);
export function usePinSlotContext() {
    return useContext(PinSlotContext);
}
